import { getErrorMessage } from "@/helpers/handleErrorResponse";
import {
  AdminAreaData,
  AdminAreaHierarchy,
  AdministrativeArea,
  AdministrativeAreaExtract,
  GetAdminAreaPayload
} from "@/types/adminArea";
import { CustomError } from "@/utils/errors";

import axiosInstance from "../config";

export const getAdminAreaByLevelApi = async (payload: GetAdminAreaPayload) => {
  try {
    const { data } = await axiosInstance.get("/v1/administrative-areas", {
      params: payload
    });
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    const newError = new CustomError(message, status);
    throw newError;
  }
};

export const getAllAdminAreaApi = async (
  payload: GetAdminAreaPayload
): Promise<AdminAreaData> => {
  let currentPage = 1;
  const perPage = payload.per_page ?? 10;
  let allData: AdministrativeArea[] = [];
  let hasNextPage = true;

  while (hasNextPage) {
    const response: AdminAreaData = await getAdminAreaByLevelApi({
      ...payload,
      page: currentPage,
      per_page: perPage
    });
    allData = allData.concat(response.data);

    const total = response.meta?.pagination?.total ?? 0;
    const totalPages = Math.ceil(total / perPage);
    currentPage += 1;
    hasNextPage = currentPage <= totalPages;
  }
  const aminAreaData: AdminAreaData = {
    data: allData
  };

  return aminAreaData;
};

export const getAdminAreaByIdApi = async (
  id: string,
  zoomLevel?: number
): Promise<AdministrativeAreaExtract> => {
  try {
    const { data } = await axiosInstance.get(`/v1/administrative-areas/${id}`, {
      params: {
        zoom_level: zoomLevel ? Math.floor(zoomLevel) : 15
      }
    });
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    const newError = new CustomError(message, status);
    throw newError;
  }
};

export const getAdminAreaHierarchy = async (
  countryId: string
): Promise<{
  data: AdminAreaHierarchy[];
}> => {
  try {
    const { data } = await axiosInstance.get(
      `/v1/administrative-areas/hierarchy`,
      {
        params: { country_id: countryId }
      }
    );
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    const newError = new CustomError(message, status);
    throw newError;
  }
};
